import type { ReceiptTemplate } from '../schema';

export const goodwillTemplate: ReceiptTemplate = {
  id: 'goodwill',
  name: 'Goodwill Receipt',
  brand: 'GOODWILL',
  description: 'Goodwill thrift store receipt',
  settings: {
    width: 280,
    font: 'Bit Matrix A',
    fontSize: 12,
    paperStyle: 'thermal',
    backgroundColor: '#ffffff',
    textColor: '#1a1a1a',
    showWatermark: false,
    currency: '$',
    currencyPosition: 'before',
    spacing: 'spaced',
  },
  sections: [
    {
      id: 'gw-header',
      type: 'header',
      enabled: true,
      config: {
        alignment: 'center',
        logoUrl: '/logos/goodwill.png',
        logoData: '',
        logoWidth: 100,
        logoHeight: 40,
        businessName: '',
        businessNameFontSize: 20,
        addressLines: [
          'INDUSTRIES',
          'STORE #489',
          '1200 DARK AVENUE',
          'MONSTERVILLE, CA 94608',
        ],
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'gw-datetime',
      type: 'datetime',
      enabled: true,
      config: {
        alignment: 'center',
        dateTime: new Date().toISOString(), format: 'MM/DD/YYYY hh:mm A',
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'gw-items',
      type: 'items-list',
      enabled: true,
      config: {
        alignment: 'left',
        items: [
          { id: '1', name: 'MENS SHIRT', quantity: '1', price: '5.99', sku: '' },
          { id: '2', name: 'WOMENS JEANS', quantity: '1', price: '7.99', sku: '' },
          { id: '3', name: 'HARDCOVER BOOK', quantity: '2', price: '2.99', sku: '' },
          { id: '4', name: 'KITCHEN BOWL', quantity: '1', price: '3.99', sku: '' },
        ],
        showQuantity: true,
        showSku: false,
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'gw-totals',
      type: 'totals',
      enabled: true,
      config: {
        alignment: 'right',
        labelPosition: 30,
        lines: [
          { id: 'subtotal', label: 'SUBTOTAL', value: '23.95', isBold: false, isLarge: false },
          { id: 'tax', label: 'TAX', value: '1.98', isBold: false, isLarge: false },
          { id: 'total', label: 'TOTAL', value: '25.93', isBold: true, isLarge: true },
        ],
        increaseTotalSize: false,
        totalSizeIncrease: 0,
        showDivider: true,
        dividerStyle: 'solid',
      },
    },
    {
      id: 'gw-payment',
      type: 'payment',
      enabled: true,
      config: {
        alignment: 'left',
        method: 'CASH',
        fields: [
          { id: 'tend', label: 'CASH:', value: '30.00' },
          { id: 'change', label: 'CHANGE:', value: '4.07' },
        ],
        showDivider: true,
        dividerStyle: 'dashed',
      },
    },
    {
      id: 'gw-footer',
      type: 'custom-message',
      enabled: true,
      config: {
        alignment: 'center',
        message: 'YOUR PURCHASE SUPPORTS\nJOB TRAINING PROGRAMS\n\nALL SALES FINAL\nTHANK YOU',
        fontSize: 12,
        showDivider: false,
        dividerStyle: 'solid',
        isBold: false,
      },
    },
  ],
  updatedAt: new Date().toISOString(),
};

